module.exports = __webpack_public_path__ + "media/images/icon__point--lost@3x-52707ff17e071537ae49838d7ebc222b.png";